import React from "react";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {BoxScoresWidgetTableStatsCells} from "./box-scores-widget.table-stats.cells";
import {PlayersStatisticsTableRowSummaryRowViewModel} from "../../../../domain/yard/lineups/players-statistics/tables/rows/summary/players-statistics.table.row.summary-row.view-model";
import classnames from "classnames";
import styles from "../../styles/box-scores-widget.module.scss";

class BoxScoresWidgetTableStatsSummariesProps extends BaseProps {
  summary: Array<PlayersStatisticsTableRowSummaryRowViewModel>;
  showAllStats: Boolean;
}

export const BoxScoresWidgetTableStatsSummaries = ((props: BoxScoresWidgetTableStatsSummariesProps) => {
  return (
    <>
      {
        props.summary?.map((summary: PlayersStatisticsTableRowSummaryRowViewModel, index: Number) =>
          <BoxScoresWidgetTableStatsCells
            className={classnames(styles.table_cell, styles.table_summary, {[styles.table_summary_row]: index === 0})}
            values={summary.values}
            emptyCell={''}
            showAllStats={props.showAllStats}
            key={index}
          />)
      }
    </>
  )
});
